var map = {
	"./admin-control-panel-tkl/admin-control-panel-tkl.edit": 419,
	"./article-edit-button/article-edit-button.edit": 420,
	"./article-new-button/article-new-button.edit": 421,
	"./base.edit": 1,
	"./booking-conference/booking-conference.edit": 422,
	"./booking-courts/booking-courts.edit": 423,
	"./booking-list-tkl/booking-list-tkl.edit": 424,
	"./booking-wellness/booking-wellness.edit": 425,
	"./category-hlasludu-personal-detail-closed/category-hlasludu-personal-detail-closed.edit": 426,
	"./category-hlasludu-personal-detail-open/category-hlasludu-personal-detail-open.edit": 427,
	"./category-hlasludu-personal/category-hlasludu-personal.edit": 428,
	"./category-hlasludu/category-hlasludu.edit": 429,
	"./category/category.edit": 430,
	"./club-detail/club-detail.edit": 431,
	"./club-search/club-search.edit": 432,
	"./coach-search-szts/coach-search-szts.edit": 433,
	"./competition-matches/competition-matches.edit": 434,
	"./competition-schedule/competition-schedule.edit": 435,
	"./competition-selector/competition-selector.edit": 436,
	"./competition-table/competition-table.edit": 437,
	"./contracts/contracts.edit": 438,
	"./couples-detail/couples-detail.edit": 439,
	"./couples-search/couples-search.edit": 440,
	"./detail-title/detail-title.edit": 441,
	"./detail/detail.edit": 442,
	"./discussion-replies/discussion-replies.edit": 443,
	"./discussion/discussion.edit": 444,
	"./event-calendar/event-calendar.edit": 445,
	"./event-detail-szts/event-detail-szts.edit": 446,
	"./event-detail/event-detail.edit": 447,
	"./event-list-sgf/event-list-sgf.edit": 448,
	"./event-list-szts/event-list-szts.edit": 449,
	"./event-list/event-list.edit": 450,
	"./file-list-without-date/file-list-without-date.edit": 451,
	"./file-list/file-list.edit": 452,
	"./gallery/gallery.edit": 453,
	"./hall-of-fame/hall-of-fame.edit": 454,
	"./html-table/html-table.edit": 455,
	"./iframe/iframe.edit": 456,
	"./image-for-button-widget-szts/image-for-button-widget-szts.edit": 457,
	"./image-for-grid-sgf/image-for-grid-sgf.edit": 458,
	"./image-for-image-widget-szts/image-for-image-widget-szts.edit": 459,
	"./image-rotator/image-rotator.edit": 460,
	"./image/image.edit": 461,
	"./join-us-tkl/join-us-tkl.edit": 462,
	"./join-us-v2/join-us-v2.edit": 463,
	"./join-us/join-us.edit": 464,
	"./list-members-tkl/list-members-tkl.edit": 465,
	"./list-members/list-members.edit": 466,
	"./live-center/live-center.edit": 467,
	"./login-tkl/login-tkl.edit": 468,
	"./login/login.edit": 469,
	"./match-events/match-events.edit": 470,
	"./match-highlight/match-highlight.edit": 471,
	"./match-players/match-players.edit": 472,
	"./member-detail-personal-tkl/member-detail-personal-tkl.edit": 473,
	"./member-detail-personal/member-detail-personal.edit": 474,
	"./member-detail/member-detail.edit": 475,
	"./menu-2/menu-2.edit": 476,
	"./menu-zosr/menu-zosr.edit": 477,
	"./menu/menu.edit": 478,
	"./offering-detail/offering-detail.edit": 479,
	"./offering-list/offering-list.edit": 480,
	"./password-change/password-change.edit": 481,
	"./password-forgotten/password-forgotten.edit": 482,
	"./password-reset/password-reset.edit": 483,
	"./person-search/person-search.edit": 484,
	"./proposal-final-create-button/thesis-create-button.edit": 485,
	"./proposal-submitted-another-subject-create-button/thesis-create-button.edit": 486,
	"./public-registration-with-payment/public-registration-with-payment.edit": 487,
	"./pure-html/pure-html.edit": 488,
	"./registration-form-zosr/registration-form-zosr.edit": 489,
	"./roster-detail-svf-digital/roster-detail-svf-digital.edit": 490,
	"./roster-detail-svf/roster-detail-svf.edit": 491,
	"./roster-detail-szpz/roster-detail-szpz.edit": 492,
	"./roster-detail/roster-detail.edit": 493,
	"./roster-list-szpz/roster-list-szpz.edit": 494,
	"./rosters/rosters.edit": 495,
	"./school-detail/school-detail.edit": 496,
	"./school-list/school-list.edit": 497,
	"./showcase/showcase.edit": 498,
	"./test/test.edit": 499,
	"./time-countdown/time-countdown.edit": 500,
	"./user-task-detail/user-task-detail.edit": 501,
	"./venues/venues.edit": 502,
	"./voting-category/voting-category.edit": 503,
	"./voting-delegated-votes-delegate/voting-delegated-votes-delegate.edit": 504,
	"./voting-delegated-votes-user/voting-delegated-votes-user.edit": 505,
	"./voting-delegation-user/voting-delegation-user.edit": 506,
	"./voting-field/voting-field.edit": 507,
	"./voting/voting.edit": 508
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 418;


//////////////////
// WEBPACK FOOTER
// ./src/widgets ^\.\/.*\.edit$
// module id = 418
// module chunks = 0